import { create } from "../../../common/utils/zustand_state_manager";
import { useTerceirizacaoServices } from "./use_services";
import { IDiarioObraRepository } from "../../../features/diarioObra/domain/repositories/diario_obra_repository";
import { DiarioObraRepository } from "../../../features/diarioObra/data/repositories/diario_obra_repository";
import { ITerceirizacaoRepository } from "../../../features/terceirizacao/domain/repositories/terceirizacao_repository";
import { TerceirizacaoRepository } from "../../../features/terceirizacao/data/repositories/terceirizacao_repository";

//useTerceirizacaosRepositories

type State = {
  terceirizacaoRepository: ITerceirizacaoRepository,
};

export const useTerceirizacaosRepositories = create<State>((set, get) => {
  const { terceirizacaoService } = useTerceirizacaoServices.getState();
  return ({
    terceirizacaoRepository: new TerceirizacaoRepository(terceirizacaoService),
  });
});